module.exports = __webpack_public_path__ + "static/media/car.be9688d8.svg";